/* eslint-disable */

import strenghtsAndGaps3 from "components/smart-scratchpad/strenghts-and-gaps-3";
import shuffled from "../../components/smart-search/shuffled";
import { jyranians } from "./jyranians";

export let headingsFromTitle = (mergedTopic: string) => `
@temp 0

Break 'What are my personal goals?" down into 10 subheading-answers.
My personal growth 
My health & fitness
My mental health & well-being
Developing my emotional intelligence
Spiritual growth
My relationships
My communication skills
Conflict resolution
Better managing my time
Financial stability

Break 'What has gone well for me in the past year?' down into 10 subheading-answers.
My career
My personal development
My relationships
My health and fitness
My financial stability
My adventures
Learning
Hobbies
My mental health & well-being
Contributing to my community

Use newlines, not numbers.
Write in first-person.
Keep it simple.
Break '${mergedTopic}' down into 15 short subheading-answers.`;

export let mergeTopic = (title: string, topic: string, subtopic: string) => `
Rewrite '${topic}' to specifically relate to '${subtopic}'.`;

export let startersFromSubtitle = (
  subtitle: string,
  title: string,
  attitude: string = "Socrates",
) => `

List 7
# What has gone well for me in the past year?
## My travels:
->Stepping out of my comfort zone
Exploring new cultures
Creating memories
Gaining my independence
Expanding my horizons
Meeting new people
Understanding the world

List 5
# What has gone well for me in the past year?
## Developing skills:
->My language and writing
My creative side
My professional skills
My hobbies or interests
My social skills

List 4
# What has gone well for me in the past year?
## My career:
->My professional development
Learning from past mistakes
Networking
Taking on new challenges

List 15
# ${title}
## ${subtitle}:
->`;

// Select a random Jyranian
let j = () => {
  let jyranian = jyranians[Math.floor(Math.random() * jyranians.length)];
  return jyranian;
};

export let startersFromSubtitleWithAttitude = (subtitle: string, title: string) => `
List 6 things I could write under the heading '# ${title}' and subheading '## ${subtitle}'.
For each thing, choose a Leader, and write with that leader's philosophical attitude.

Leadership Attitudes:
${shuffled(jyranians).join("\n")}

List 7
# What has gone well for me in the past year?
## My travels:
->${j()}: Stepping out of my comfort zone
${j()}:Ranulph Fiennes: Exploring new cultures
${j()}Dalai Lama: Creating memories
${j()}Wu Zetian: Gaining my independence
${j()}Estee Lauder: Expanding my horizons
${j()}Albert Einstein: Meeting new people
${j()}Richard Branson: Understanding the world

List 5
# What has gone well for me in the past year?
## Developing skills:
->${j()}: My language and writing
${j()}: My creative side
${j()}: My professional skills
${j()}: My hobbies or interests
${j()}: My social skills

List 100
# ${title}
## ${subtitle}:
->`;

export let headingsFromSubtitle = (subtitle: string, title: string) => `

Break 'Traveling & having adventures' down into 6 headings to help me understand 'What have I accomplished in the last year?'.
Exploring new cultures
Stepping out of my comfort zone
Travelling & making memories
Gaining my independence
Broadening my horizons
Meeting new people

Break 'Developing skills' down into 5 headings to help me understand 'What have I accomplished in the last year?'.
Developing my language & writing skills
Developing creatively
Developing my professional skills
Developing skills related to my hobbies or interests
Developing my social skills

Break '${subtitle}' down into 10 headings to help me understand '${title}'`;

export let getContinuations = (phrase: string, subtitle: string, title: string) => `

# What has gone well for me in the past year?
## My hobbies
My hobbies have helped me relax and de-stress...
List 6
1)..., bringing joy and fulfillment.
2)... letting me get away from daily life.
3)...; let me explore my creativity and express myself.
4)..., giving me a sense of nostalgia for my childhood.
5)..., stay active, and maintain my physical health.
6)..., and to connect with like-minded individuals.


# ${title}
## ${subtitle}
${phrase}...
List 6
1)...`;

// A function that takes a number and converts it into an uppercase letter.
export let numberToLetter = (n: number) => {
  return String.fromCharCode(65 + n);
};

// A function that converts back to a number.
export let letterToNumber = (l: string) => {
  return l.charCodeAt(0) - 65;
};

export let getReasoning = (options: { text: string }[], title: string, sn: number) => `
@temp 0.8

## Areas of my life (with codes)
${options.map((o, i) => `${o.text} (${codes[i]})`).join("\n")}

## My Top Strengths
Strength A: $subject-user.solo.strength-ratings.1 - $subject-user.solo.strength-ratings.1.description
Strength B: $subject-user.solo.strength-ratings.2 - $subject-user.solo.strength-ratings.2.description
Strength C: $subject-user.solo.strength-ratings.3 - $subject-user.solo.strength-ratings.3.description
Strength D: $subject-user.solo.strength-ratings.4 - $subject-user.solo.strength-ratings.4.description
Strength E: $subject-user.solo.strength-ratings.5 - $subject-user.solo.strength-ratings.5.description
Strength F: $subject-user.solo.strength-ratings.6 - $subject-user.solo.strength-ratings.6.description
Strength G: $subject-user.solo.strength-ratings.7 - $subject-user.solo.strength-ratings.7.description
Strength H: $subject-user.solo.strength-ratings.8 - $subject-user.solo.strength-ratings.8.description
Strength I: $subject-user.solo.strength-ratings.9 - $subject-user.solo.strength-ratings.9.description
Strength J: $subject-user.solo.strength-ratings.10 - $subject-user.solo.strength-ratings.10.description


Do the following 15 (fifteen) times.
- Strengths: Pick three, four, or five of my top strengths.
- Area: Choose an area of my life those strengths might have help me with in the past year. Include the code eg 000.

1.
- Strengths: Strength`;

export let getReasoning2 = (strengthIndexes: number[], area: string) => `
## My Top Strengths:
${strengthIndexes
  .map(
    (si) =>
      `$subject-user.solo.strength-ratings.${si + 1} - $subject-user.solo.strength-ratings.${
        si + 1
      }.description`,
  )
  .join("\n")}

## Area of my life:
${area}

Write a sentence about how those strengths combined have helped me in that area of my life. Write in first person.

Assistant: Ok. Here's the sentence:`;

export let codes = [
  "433",
  "273",
  "113",
  "386",
  "226",
  "499",
  "339",
  "179",
  "452",
  "292",
  "132",
  "405",
  "245",
  "518",
  "358",
  "198",
  "471",
  "311",
  "151",
  "424",
  "264",
  "104",
  "377",
  "217",
  "490",
  "330",
  "170",
  "443",
  "283",
  "123",
  "396",
  "236",
  "509",
  "349",
  "189",
  "462",
  "302",
  "142",
  "415",
  "255",
  "368",
  "208",
  "481",
  "321",
  "161",
  "434",
  "274",
  "114",
  "387",
  "227",
  "340",
  "180",
  "453",
  "293",
  "133",
  "406",
  "246",
  "519",
  "359",
  "199",
  "472",
  "312",
  "152",
  "425",
  "265",
  "105",
  "378",
  "218",
  "491",
  "331",
  "171",
  "444",
  "284",
  "124",
  "397",
  "237",
  "510",
  "350",
  "190",
  "463",
  "303",
  "143",
  "416",
  "369",
  "209",
  "482",
  "322",
  "162",
  "435",
  "275",
  "115",
  "388",
  "228",
  "501",
  "341",
  "181",
  "454",
  "294",
  "134",
  "407",
];

// codes is an array with the numbers 102 to 519 in it. All 3-digit numbers are 1-token and are mostly irrelevant.
// let codes = [] as number[];
// let excludedCodes = ["128", "256", "512", "100", "200", "300", "400", 500]; // Exclude significant numbers.

// for (let i = 102; i < 520; i++) {
//   if (!excludedCodes.includes(i)) {
//     codes.push(i);
//   }
// }

// // Sort codes in a reliably random way.
// codes.sort((a, b) => ((b * 50153) % 2099) - ((a * 50153) % 2099));

// codes = codes.slice(0, 100);
// console.log(codes);

export let reasoningBias2 = {};

export let getWatermark = (
  body: string,
  title: string,
  heading: string,
  phrase: string,
) => `@temp 1.3
#Topic: ${title}

${body}

Title: # ${title || "(none)"}
Current heading: ## ${heading || "(none)"}
Current line: ${phrase || "(none)"}

Write a question to prompt me to continue my reflection. It should be relevant to the Current heading, Current line, and the title.
`;
